import React, { useState, useMemo } from 'react';
import { Button } from 'reactstrap';
import { Icon } from 'js/components';
import { faListTree } from '@fortawesome/pro-regular-svg-icons';

import {
  CapabilitySelector,
  SelectedCapabilityList,
} from 'js/components/Capabilities';

import styles from './ManagedProductSettings.module.scss';

function ProductCapabilitiesList({
  managedProduct,
  capabilitySets,
  onLinkCapability,
  onUnlinkCapability,
  onLinkCapabilities,
  onUnlinkCapabilities,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const linkedCapabilities = useMemo(() => {
    return Object.fromEntries(
      (managedProduct?.capability_ids ?? []).map((cId) => {
        const capability = (managedProduct?.capabilities ?? []).find(
          (c) => c.id === cId
        );
        return [cId, capability ? capability.capability_set_id : true];
      })
    );
  }, [managedProduct?.capability_ids, managedProduct?.capabilities]);

  const chosenSets = useMemo(() => {
    const uniqueSets = new Set();

    managedProduct?.capabilities?.forEach((c) => {
      uniqueSets.add(c.capability_set_id);
    });

    return (capabilitySets ?? []).filter((cs) => uniqueSets.has(cs.id));
  }, [capabilitySets, managedProduct?.capabilities]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start">
        <h5>Capabilities</h5>
        <Button
          color="primary"
          className="mt-1 btn-inline"
          style={{ fontSize: '1em' }}
          onClick={() => setIsOpen(true)}
        >
          <Icon icon={faListTree} />
        </Button>
      </div>
      {chosenSets.length === 0 && (
        <p>This product is not associated with any capabilities.</p>
      )}
      {chosenSets?.map((capabilitySet) => (
        <div key={capabilitySet.id} className={styles['capability-set']}>
          <h6>{capabilitySet.name}</h6>
          <SelectedCapabilityList
            capabilitySet={capabilitySet}
            selectedCapabilities={linkedCapabilities}
          />
        </div>
      ))}

      <CapabilitySelector
        capabilitySets={capabilitySets}
        selectedCapabilities={linkedCapabilities}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSelectCapability={onLinkCapability}
        onDeselectCapability={onUnlinkCapability}
        onSelectCapabilities={onLinkCapabilities}
        onDeselectCapabilities={onUnlinkCapabilities}
      />
    </div>
  );
}

export default ProductCapabilitiesList;
